import { makeHttpGet, makeHttpMutate } from '_api';

import { useTokenStoreValue } from '../stores/user';
import { getSimulator } from '../config/simulators';

export const useHttpGet = makeHttpGet(useTokenStoreValue, getSimulator);

export const useHttpMutate = makeHttpMutate(useTokenStoreValue, getSimulator);
